// Frontend mirror of backend/permissions.py role matrix (PRD §B).
//
// These helpers gate UI affordances so a role never sees a button it cannot
// successfully press. Backend still enforces the same rules — these are pure
// UX. Keep them aligned with `backend/permissions.py`; drift means the UI
// either shows dead buttons or hides legitimate ones.

export const ROLES = [
  "owner",
  "admin",
  "designer",
  "operator",
  "signer",
  "auditor",
  "lawyer",
];

const has = (role, allowed) => Boolean(role) && allowed.includes(role);

// Phase OC — закрытый раздел «Документы компании»: только owner + юрист
// (mirror of backend READ/WRITE_COMPANY_DOCUMENTS).
export const canAccessCompanyDocuments = (role) => has(role, ["owner", "lawyer"]);

export const canManageOrg = (role) => has(role, ["owner", "admin"]);
export const canManageMembers = (role) => has(role, ["owner", "admin"]);
export const canManageWorkflows = (role) =>
  has(role, ["owner", "admin", "designer"]);
export const canManageTemplates = (role) =>
  has(role, ["owner", "admin", "designer", "operator"]);
export const canManageContractors = (role) =>
  has(role, ["owner", "admin", "designer", "operator"]);
// Phase V — Канцелярия/ЕСЭДО: регистрация и отправка корреспонденции
// (mirror of backend WRITE_CORRESPONDENCE). Чтение журналов — у всех членов.
export const canManageCorrespondence = (role) =>
  has(role, ["owner", "admin", "operator"]);
export const canUploadDocuments = (role) =>
  has(role, ["owner", "admin", "designer", "operator"]);
export const canSendDocuments = (role) =>
  has(role, ["owner", "admin", "designer", "operator"]);
export const canCompleteTasks = (role) =>
  has(role, ["owner", "admin", "designer", "operator", "signer"]);
export const canSignDocuments = (role) =>
  has(role, ["owner", "admin", "designer", "operator", "signer"]);
export const canDeleteAnyDocument = (role) => has(role, ["owner", "admin"]);
export const canDeleteOwnDocument = (role) =>
  has(role, ["owner", "admin", "operator"]);
export const canViewAuditLog = (role) => has(role, ["owner", "admin"]);
// Phase I — reports surface is owner/admin only (audit-logged on access).
export const canViewReports = (role) => has(role, ["owner", "admin"]);
export const canPromoteToOwner = (role) => role === "owner";
// Phase E — admins/owners can override-complete a task on someone else's behalf
// (audit-distinct action `task.override_completed`).
export const canOverrideTask = (role) => has(role, ["owner", "admin"]);
